import Alert from 'common/components/alert/Alert';
import FinalFormField from 'common/components/final-form/FinalFormField';
import AlertType from 'common/types/AlertType';
import constants from 'domain/constants';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { Link } from 'react-router-dom';

interface ISharedHousingLicensePresenter {
  data: { licenseNumber: number | null };
  onSubmit: (values: Record<string, string>) => void;
  error: string | null;
  success: boolean;
  saving: boolean;
  successContent: React.ReactNode;
}

const SharedHousingLicensePresenter = (
  props: ISharedHousingLicensePresenter
) => {
  let msg = null;
  if (props.error) {
    msg = <Alert type={AlertType.danger}>{props.error}</Alert>;
  } else if (props.success && props.successContent) {
    msg = <Alert type={AlertType.success}>{props.successContent}</Alert>;
  } else if (props.data.licenseNumber) {
    msg = (
      <Alert type={AlertType.success}>
        {props.successContent ||
          "A valid Operator's License has been added to your profile."}
      </Alert>
    );
  }

  return (
    <>
      <p>
        A <i>Shared Housing Unit Operator</i> is an owner or operator of more
        than one <i>shared housing unit</i>.
      </p>
      <p>
        Please enter your Shared Housing Unit Operator’s license below in order
        to purchase more than one short term rental registration number. For
        more information,{' '}
        <Link to={`${constants.STATIC_PAGE_ROUTE}/contact`}>contact BACP</Link>.
      </p>

      {msg}
      <Form onSubmit={props.onSubmit} initialValues={props.data}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FinalFormField
              name='licenseNumber'
              label='License Number'
              type='number'
              disabled={Boolean(props.data.licenseNumber)}
            />
            {!props.data.licenseNumber && (
              <Button type='submit' variant='primary' disabled={props.saving}>
                Submit
              </Button>
            )}
          </form>
        )}
      </Form>
    </>
  );
};

export default SharedHousingLicensePresenter;
